import APIController from "./APIController"
import { useWebSocket } from "../Context/WebSocketContext"
const CashRegisterController = () =>{
    const {jsonRequest, getWorkspaceId} = APIController()
    const {isOnline} = useWebSocket()

    const getStatisticsEntries = async (startDate, endDate) => {
        const workspaceId = await getWorkspaceId()
        if (!workspaceId || !isOnline) return null;
        const startISO = new Date(startDate).toISOString();
        const endISO = new Date(endDate).toISOString();
        const data = await jsonRequest(`/${workspaceId}/register_entries?startTime=${startISO}&endTime=${endISO}`);
        return data;
    };

    return{
        getStatisticsEntries
    }
}
export default CashRegisterController